export default {
      id: "twitter-negative-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#twitter-negative",
      toString: function () {
        return this.url;
      }
    }